export enum ReviewStatus {
  PendingReview = 1,
  Confirmed = 2,
  Approved = 3,
  AwaitingRevision = 4,
  Revised = 5,
  None = 9,
}
